import React from 'react'
import Marquee from "react-fast-marquee";

const Carousel = () => {
  return (
    <div className="carousel">
        <Marquee loop={0} pauseOnHover	speed={100}>
            Celestial Biscuit IGDTUW • Celestial Biscuit IGDTUW • Celestial Biscuit IGDTUW • Celestial Biscuit IGDTUW • Celestial Biscuit IGDTUW • Celestial Biscuit IGDTUW • Celestial Biscuit IGDTUW • Celestial Biscuit IGDTUW • 
        </Marquee>

    </div>

  )
}

export default Carousel